<template>
  <el-card shadow="never">
    <el-page-header @back="goBack" content="服务商列表"> </el-page-header>
    <!-- 内容 -->
    <div class="renew-operator-form">
      <el-form
        :label-position="labelPosition"
        label-width="120px"
        :model="formOperatorInfo"
      >
        <el-form-item label="商家logo">
          <up-load
            :default_image="formOperatorInfo.logo"
            @getImageURl="getLogo"
          ></up-load>
        </el-form-item>
        <el-form-item label="服务名称">
          <el-input
            style="width: 200px"
            size="mini"
            v-model="formOperatorInfo.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="当地/英文名称">
          <el-input
            style="width: 200px"
            size="mini"
            v-model="formOperatorInfo.loc_name"
          ></el-input>
        </el-form-item>
        <!-- 服务商 -->
        <el-form-item label="服务商所在地">
          <el-cascader
            style="width: 200px"
            size="mini"
            :show-all-levels="false"
            v-model="formOperatorInfo.new_dest"
            :options="option"
            @change="handleChoice"
            :props="defaultProp"
            clearable
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
            style="width: 300px"
            type="textarea"
            size="mini"
            v-model="formOperatorInfo.address"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input
            style="width: 200px"
            size="mini"
            v-model="formOperatorInfo.manager"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            style="width: 200px"
            size="mini"
            v-model="formOperatorInfo.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item label="介绍">
          <el-input
            style="width: 300px"
            type="textarea"
            size="mini"
            v-model="formOperatorInfo.introduce"
          ></el-input>
        </el-form-item>
        <div style="margin: 50px 0">
          <el-divider content-position="left">其他信息</el-divider>
        </div>
        <!-- 证书logo -->
        <el-form-item label="证书logo">
          <up-load
            :default_image="formOperatorInfo.operator_logo"
            @getImageURl="getOperatorLogo"
          ></up-load>
        </el-form-item>
        <!-- 公众账号 -->
        <el-form-item label="公众号二维码">
          <up-load
            :default_image="formOperatorInfo.operator_wechat_public_qrcode"
            @getImageURl="getQrcode"
          ></up-load>
        </el-form-item>

        <el-form-item label="微信公众号">
          <el-input
            style="width: 300px"
            size="mini"
            v-model="formOperatorInfo.wechat_public_account"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button size="mini" @click="cancelAdditionForm">取 消</el-button>
        <el-button size="mini" type="primary" @click="confirmAdditionAdd"
          >提 交</el-button
        >
      </div>
    </div>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
export default {
  name: "operator-add-renew",
  components: {
    UpLoad,
  },
  data() {
    return {
      labelPosition: "left",
      formOperatorInfo: {
        logo: "",
        name: "",
        loc_name: "",
        address: "",
        new_dest: [],
        manager: "",
        mobile: "",
        introduce: "",
        operator_wechat_public_qrcode: "",
        wechat_public_account: "",
      },
      //   服务商
      defaultProp: {},
      //   new_dest: [], 移动到表单中
      option: [],
      defaultProp: {
        // 联系选择器的属性，比如是否可以多选等
        multiple: true, //是否多选
        checkStrictly: true, // 是否严格的遵守父子节点不互相关联
        label: "loc_name", // 指定选项标签为选项对象的某个属性值
        value: "loc_id", // 指定选项的值为选项对象的某个属性值
        children: "children", // 指定选项的子选项为选项对象的某个属性值
      },
      //
    };
  },
  created() {
    if (this.$route.query.op_id) {
      this.formOperatorInfo.op_id = this.$route.query.op_id;
      this.getOperatorInfor(this.$route.query.op_id);
    }
    this.loadDest();
  },
  methods: {
    getOperatorLogo(value) {
      this.formOperatorInfo.operator_logo = value;
    },
    getQrcode(value) {
      this.formOperatorInfo.operator_wechat_public_qrcode = value;
    },
    getLogo(value) {
      this.formOperatorInfo.logo = value;
    },
    //  获取operator信息
    getOperatorInfor(op_id) {
      this.$http
        .get(`/product/get_operator_info?operator_id=${op_id}`)
        .then((res) => {
          if (res.data.errno == "0") {
            console.log(res);
            this.formOperatorInfo.logo = res.data.data.logo;
            this.formOperatorInfo.name = res.data.data.name;
            this.formOperatorInfo.loc_name = res.data.data.loc_name;
            this.formOperatorInfo.address = res.data.data.address;
            // 地址
            this.formOperatorInfo.new_dest = res.data.data.dest_group;
            this.formOperatorInfo.manager = res.data.data.manager;
            this.formOperatorInfo.mobile = res.data.data.mobile;
            this.formOperatorInfo.introduce = res.data.data.introduce;
            this.formOperatorInfo.operator_logo = res.data.data.operator_logo;
            //
            this.formOperatorInfo.operator_wechat_public_qrcode =
              res.data.data.wechat_public_qrcode;
            this.formOperatorInfo.wechat_public_account =
              res.data.data.wechat_public_account;
            if (res.data.data.wx_public) {
              this.formOperatorInfo.operator_wechat_public_qrcode =
                res.data.data.wx_public.wx_public_qrcode;
              this.formOperatorInfo.wechat_public_account =
                res.data.data.wx_public.wx_public_account;
            }
          } else {
            this.$notify({
              title: "警告",
              message: res.data.errmsg,
              type: "warning",
            });
          }
        });
    },
    cancelAdditionForm() {
      this.$router.push({
        name: "operator_list",
      });
    },
    goBack() {
      this.$router.push({
        name: "operator_list",
      });
    },
    handleChoice() {},
    confirmAdditionAdd() {
      //   console.log(this.formOperatorInfo);
      //   return;
      this.$http
        .post("/product/add_operator_info", this.formOperatorInfo)
        .then((res) => {
          //   console.log(res);
          if (res.data.errno == "0") {
            this.$notify({
              title: "成功",
              message: res.data.errmsg,
              type: "success",
            });
            this.$router.push({
              name: "operator_list",
            });
          } else {
            this.$notify({
              title: "警告",
              message: res.data.errmsg,
              type: "warning",
            });
          }
        });
    },
    // 获取 目的地信息
    loadDest() {
      this.$http.get("/get_dest_level").then((res) => {
        this.option = res.data.data;
      });
    },
  },
};
</script>

<style>
.renew-operator-form {
  padding: 80px 20px 20px;
}
</style>